import DownloadAppQrCode from '@molecules/DownloadAppQrCode';
import { Image, Text } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import { useWindowSize } from '@uidotdev/usehooks';
import { useState } from 'react';
import texts from "./en.json";

const DownloadAppBanner = () => {
    const { width } = useWindowSize();
    const [showAppDownloadPrompt, setShowAppDownloadPrompt] = useState(false);

    return (
        <div className="px-6 pt-4 bg-download-app-active-opportunities rounded-t-2xl flex gap-4 items-center">
            <Image src="/images/mobile-app.png" className="w-11 animate-slide-up" />
            <div className='flex flex-col gap-2 pb-3'>
                <Text
                    content={texts?.DownloadAppBannerText}
                    className="text-basicWhite p5-semibold"
                    htmlTag='h3'
                />
                <Button
                    buttonType="textunderline"
                    buttonText={texts?.DownloadJiraafApp}
                    prefixComponent={
                        <Image
                            src={'/images/download-arrow-down-tray-white.svg'}
                            className="w-4 h-4"
                            alt='download'
                        />
                    }
                    className="relative md:left-0 px-0"
                    onClick={() => {
                        if (width < 1024) {
                            window.open(appDownloadLink, '_blank');
                        } else {
                            setShowAppDownloadPrompt(true);
                        }
                    }}
                    textClassName="!text-basicWhite p5-underline"
                />
            </div>

            {showAppDownloadPrompt && (
                <DownloadAppQrCode
                    show={showAppDownloadPrompt}
                    onClose={() => setShowAppDownloadPrompt(false)}
                />
            )}
        </div>
    );
};

export default DownloadAppBanner;
